import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ImageLibpixel from "./image-libpixel.js";

const BannerWrapper = styled.div`
  width: 100%;
  height: 306px;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  margin: 80px 0;
  @media (max-width: 1030px) {
    height: 280px;
    justify-content: space-around;
    margin-top: 20px 0;
  }
  @media (max-width: 440px) {
    display: none;
  }
`;
const BGImg = styled(ImageLibpixel)`
  width: 100%;
  height: 306px;
  object-fit: cover;
  transition: all 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  position: absolute;
  top: 0;
  left: 0;
  @media (min-width: 1031px) {
    &:hover {
      transform: scale(1.1);
    }
  }
  @media (max-width: 1030px) {
    height: 280px;
  }
`;
const BGImgShadow = styled.div`
  width: 100%;
  height: 306px;
  background-color: #000;
  opacity: 0.2;
  filter: blur(2px);
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  @media (max-width: 1030px) {
    height: 280px;
  }
`;
const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  position: relative;
  z-index: 5;
  max-width: 373px;
  pointer-events: none;
  @media (max-width: 1030px) {
    max-width: 250px;
  }
`;
const Icon = styled(ImageLibpixel)`
  width: 50px;
  height: 50px;
  @media (max-width: 1030px) {
    width: 30px;
    height: 30px;
  }
`;
const Title = styled.h2`
  font-size: 1.2rem;
  color: ${(props) => props.color};
  margin: 20px 0 10px 0;
  text-align: center;
  font-family: "Poppins", sans-serif;
  letter-spacing: 1px;
`;
const Description = styled.p`
  font-size: 0.8rem;
  color: ${(props) => props.color};
  margin: 0;
  text-align: center;
  line-height: 1.4;
  height: 75px;
  overflow: hidden;
  @media (max-width: 1030px) {
    max-width: 250px;
  }
`;

const Banner = ({ imgUrl, imgAlt, columns, txtWhite }) => {
  return (
    <BannerWrapper>
      <BGImg src={imgUrl} alt={imgAlt} />
      <BGImgShadow />
      {columns?.map((node, i) => (
        <ContentBox key={i + 1}>
          <Icon src={node.img.sourceUrl} alt={node.img.altText} />
          <Title color={txtWhite ? "white" : "black"}>{node.title}</Title>
          <Description color={txtWhite ? "white" : "black"}>
            {node.text}
          </Description>
        </ContentBox>
      ))}
    </BannerWrapper>
  );
};

Banner.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string,
      img: PropTypes.shape({
        altText: PropTypes.string,
        sourceUrl: PropTypes.string,
      }),
    })
  ),
  imgUrl: PropTypes.string,
  imgAlt: PropTypes.string,
  txtWhite: PropTypes.bool,
};

Banner.defaultProps = {
  columns: undefined,
  imgUrl: undefined,
  imgAlt: undefined,
  txtWhite: true,
};

export default Banner;
